import { p as proxyCustomElement, H, h, F as Fragment, a as Host } from './index.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$e } from './p-BbTg3Car.js';
import { d as defineCustomElement$d } from './p-7jxIfyyn.js';
import { d as defineCustomElement$c } from './p-CE-SFMeF.js';
import { d as defineCustomElement$b } from './p-BZccBFnt.js';
import { d as defineCustomElement$a } from './p-Da2lAZSv.js';
import { d as defineCustomElement$9 } from './p-DUcqAgyP.js';
import { d as defineCustomElement$8 } from './p-Cx1d0m6y.js';
import { d as defineCustomElement$7 } from './p-CEvUoLql.js';
import { d as defineCustomElement$6 } from './p-CT2oAZeh.js';
import { d as defineCustomElement$5 } from './p-CCmod1sd.js';
import { d as defineCustomElement$4 } from './p-FpOQMZxV.js';
import { d as defineCustomElement$3 } from './p-cR96ip-k.js';
import { d as defineCustomElement$2 } from './p-Bn01tsA6.js';

function isPropertySelector(parentLink) {
    if (parentLink && 'links' in parentLink) {
        return true;
    }
    return false;
}

const breadcrumbsCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;box-sizing:border-box;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.25rem;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host wui-icon{color:var(--jw-theme-surface-text-helper-color)}:host .parent-link-container{align-items:center;display:inline-flex;gap:.25rem}:host .current-page-container{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem;padding:0 .25rem}:host([truncate-breadcrumbs=true]) .parent-link-container>wui-button,:host([truncate-breadcrumbs=true]) .parent-link-container>wui-more-menu{max-width:8rem;text-overflow:ellipsis}";

const WuiBreadcrumbs$1 = /*@__PURE__*/ proxyCustomElement(class WuiBreadcrumbs extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.parentLinks = [];
        this.truncateBreadcrumbs = false;
        this.currentPageTitle = '';
    }
    renderParentLinks() {
        const [firstLink, ...restOfParentLinks] = this.parentLinks || [];
        const lastLink = restOfParentLinks.pop();
        return (h(Fragment, null, firstLink &&
            (isPropertySelector(firstLink) ? (h("span", { class: "parent-link-container" }, h("wui-more-menu", { icon: "chevron-down", iconPosition: "trailing", menuPane: {
                    placement: 'bottom-start',
                }, label: firstLink.title, buttonType: "tertiary" }, h("wui-list", null, firstLink.links.map((link, idx) => (h("wui-list-item", { key: `${link.title}-${idx}`, label: link.title, as: ['a', parseHrefProp(link.href)] }))))), h("wui-icon", { name: "slash", size: "md" }))) : (h("span", { class: "parent-link-container" }, h("wui-button", { label: firstLink.title, as: ['a', parseHrefProp(firstLink.href)], type: "tertiary" }), h("wui-icon", { name: "slash", size: "md" })))), restOfParentLinks.length === 1 && (h("span", { class: "parent-link-container" }, h("wui-button", { label: restOfParentLinks[0]?.title, as: ['a', parseHrefProp(restOfParentLinks[0]?.href)], type: "tertiary" }), h("wui-icon", { name: "slash", size: "md" }))), restOfParentLinks.length > 1 && (h("span", { class: "parent-link-container" }, h("wui-more-menu", { icon: "dots", closeOnClickInside: true }, h("wui-list", null, restOfParentLinks.map((link, idx) => (h("wui-list-item", { key: `${link.title}-${idx}`, label: link.title, as: ['a', parseHrefProp(link.href)] }))))), h("wui-icon", { name: "slash", size: "md" }))), lastLink && (h("span", { class: "parent-link-container" }, h("wui-button", { label: lastLink.title, as: ['a', parseHrefProp(lastLink.href)], type: "tertiary" }), h("wui-icon", { name: "slash", size: "md" })))));
    }
    render() {
        return (h(Host, { key: '7e3909af1fd76e0bbe7c0efd635fbe440c167bc4' }, this.renderParentLinks(), h("span", { key: '234acb81e0f9383a94a34046e964b55fe9e90649', class: "current-page-container" }, this.currentPageTitle)));
    }
    static get style() { return breadcrumbsCss; }
}, [257, "wui-breadcrumbs", {
        "parentLinks": [16, "parent-links"],
        "truncateBreadcrumbs": [516, "truncate-breadcrumbs"],
        "currentPageTitle": [1, "current-page-title"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-breadcrumbs", "wui-box", "wui-button", "wui-check-input", "wui-form-field", "wui-icon", "wui-list", "wui-list-item", "wui-loader", "wui-menu-pane", "wui-more-menu", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-breadcrumbs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiBreadcrumbs$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiBreadcrumbs = WuiBreadcrumbs$1;
const defineCustomElement = defineCustomElement$1;

export { WuiBreadcrumbs, defineCustomElement };
